module.exports = __webpack_public_path__ + "static/assets/ad74810a8379c9515a272888211921c4.png";